import { useShopMetaByKeyQuery } from '~/api/graphql/queries/shopMetaByKey.generated';
import { usePricingPlanActive } from '~/modules/pricing';
import { GEMX_ONBOARDING_DATA_KEY } from '../constants';
import { useCampaignStore } from '~/modules/campaign';
import { INavigateKey } from '~/types/navigate';
import { ROUTE_PATH } from '~/config/navigate';
import { useLocation } from '@remix-run/react';
import { useOnboardingStore } from '../stores';
import { parseShopMeta } from '~/utils';
import { useMemo } from 'react';

export const useOnboardingState = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const isQueryCampaignTemplate = useCampaignStore((state) => state.isQueryCampaignTemplate);
  const onboardingPath = useOnboardingStore((state) => state.onboardingPath);

  const { isLoading: isLoadingPlan } = usePricingPlanActive();

  const {
    data: onboardingData = {},
    isFetching: isFetchingOnboarding,
    isFetched: isFetchedOnboarding,
  } = useShopMetaByKeyQuery(
    { key: GEMX_ONBOARDING_DATA_KEY },
    { enabled: true, select: parseShopMeta },
  );

  const isOnDevMode = pathname.includes(INavigateKey.DevMode);
  const isSurveyPath = onboardingPath === ROUTE_PATH[INavigateKey.OnboardingSurvey];
  const isTemplatePath = onboardingPath === ROUTE_PATH[INavigateKey.OnboardingTemplate];
  const isMultiPagePath = onboardingPath === ROUTE_PATH[INavigateKey.OnboardingMultiPage];

  const isSetupGuidePath = isTemplatePath || isMultiPagePath;
  const isFetchedDashboardData = !isLoadingPlan && isQueryCampaignTemplate;

  const showOnboardingModal =
    !isOnDevMode && isFetchedDashboardData && (isSurveyPath || isSetupGuidePath);

  const isCurrentlyInOnboarding = pathname.includes(ROUTE_PATH[INavigateKey.OnboardingSurvey]);

  return useMemo(() => {
    return {
      pathname,
      isOnDevMode,
      isSurveyPath,
      isTemplatePath,
      isMultiPagePath,
      isSetupGuidePath,
      showOnboardingModal,
      onboardingData,
      isFetchingOnboarding,
      isFetchedOnboarding,
      isCurrentlyInOnboarding,
    };
  }, [
    pathname,
    isOnDevMode,
    isSurveyPath,
    isTemplatePath,
    isMultiPagePath,
    isSetupGuidePath,
    showOnboardingModal,
    onboardingData,
    isFetchingOnboarding,
    isFetchedOnboarding,
    isCurrentlyInOnboarding,
  ]);
};
